import { createAsyncThunk } from "@reduxjs/toolkit";

import logger from "Libs/logger";
import { environmentSelector, loadEnvironments } from "Reducers/environment";
import { gitProjectSelector } from "Reducers/project/project";
import { AsyncThunkOptionType } from "Reducers/types";

import { BranchEnvironmentActionPropType } from "../";

import type { Activity } from "Api/activity/types";

export const branch = createAsyncThunk<
  Activity,
  BranchEnvironmentActionPropType,
  AsyncThunkOptionType
>(
  "Environment/Branch/Load",
  async (
    { options, organizationId, environmentId, projectId, resourcesInit },
    { dispatch, getState, rejectWithValue }
  ) => {
    try {
      const project = gitProjectSelector(getState(), {
        organizationId,
        projectId
      });
      const environment = environmentSelector(getState(), {
        organizationId,
        projectId,
        environmentId
      });

      if (!environment) {
        return rejectWithValue({ message: "Environment not found" });
      }

      const branch = await environment.branch(
        options.branchName,
        options.type,
        resourcesInit
      );

      // Reload the environments for the benefit of components that need the newest environment state
      if (project?.id) {
        dispatch(loadEnvironments({ projectId: project.id, organizationId }));
      }
      return branch;
    } catch (err) {
      logger(err as Error, {
        action: "branch",
        payload: branch,
        options,
        meta: {
          organizationId,
          environmentId,
          projectId
        }
      });
      return rejectWithValue(err);
    }
  }
);
